
var datepickerLess = {};
import genaration from '../../utils/classname';
export var datepickerClass = genaration(datepickerLess, 'datepicker');